"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Component = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _reactRouterDom = require("react-router-dom");
var _PreviewWrapper = _interopRequireDefault(require("./PreviewWrapper"));
var _Print = _interopRequireDefault(require("./Print"));
var _Export = _interopRequireDefault(require("./Export"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _reactRedux = require("react-redux");
var _builder = require("../../reducers/builder.js");
var _player = require("../../reducers/player.js");
var _reactDndMultiBackend = require("react-dnd-multi-backend");
var _HTML5toTouch = _interopRequireDefault(require("../../HTML5toTouch.js"));
var _allElements = _interopRequireDefault(require("../../allElements.js"));
var _Elements = _interopRequireDefault(require("./Elements"));
var _Settings = _interopRequireDefault(require("./Settings"));
var _Trash = _interopRequireDefault(require("./Trash"));
var _FlowSettings = _interopRequireDefault(require("./FlowSettings"));
var _Accommodations = _interopRequireDefault(require("./Accommodations"));
var _Variables = _interopRequireDefault(require("./Variables"));
var _TextToSpeech = _interopRequireDefault(require("./TextToSpeech"));
var _FlowList = _interopRequireDefault(require("./FlowList"));
var _builder2 = require("../../selectors/builder.js");
var _helpers = require("../../other/helpers.js");
var _DataConnectorsPicker = _interopRequireDefault(require("../DataConnectorsPicker"));
var _ScrollShadow = _interopRequireDefault(require("../ScrollShadow"));
var _location = _interopRequireDefault(require("cccisd-icons/location"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _RestrictionsLevelContext = _interopRequireDefault(require("../../other/RestrictionsLevelContext.js"));
var _paragraphJustify = _interopRequireDefault(require("cccisd-icons/paragraph-justify3"));
var _fileText = _interopRequireDefault(require("cccisd-icons/file-text"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Builder = exports.Builder = /*#__PURE__*/function (_React$Component) {
  _inherits(Builder, _React$Component);
  function Builder() {
    var _this;
    _classCallCheck(this, Builder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Builder, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      builderHeight: null
    });
    _defineProperty(_assertThisInitialized(_this), "_handleUnload", function (event) {
      if (_this.props.isSaveNeeded) {
        var message = 'You have unsaved changes';
        event.returnValue = message;
        return message;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleResize", function (e) {
      if (!_this.refs.builder) {
        return;
      }
      var overlay = document.getElementById('cccisd-assignment-overlay');
      var marginBottom = overlay ? 2 * overlay.offsetTop : 16;
      var windowHeight = window.innerHeight;
      var builderOffset = _this.refs.builder.getBoundingClientRect().top;
      var builderHeight = Math.max(windowHeight - builderOffset - marginBottom, 100);
      _this.setState({
        builderHeight: "".concat(builderHeight, "px")
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_changeToBriefMode", function (event) {
      if (event) {
        event.preventDefault();
      }
      _this.props.changeViewMode('brief');
    });
    _defineProperty(_assertThisInitialized(_this), "_changeToPreviewMode", function (event) {
      if (event) {
        event.preventDefault();
      }
      _this.props.changeViewMode('preview');
    });
    _defineProperty(_assertThisInitialized(_this), "_getAllowedElements", function () {
      var flowType = _this.props.flowSettings.type;
      if (!flowType) {
        return [];
      }
      var flowTypeInfo = (0, _helpers.getFlowTypes)()[flowType];
      if (!flowTypeInfo) {
        throw new Error("There is no flow type \"".concat(flowType, "\""));
      }
      var components = flowTypeInfo.components;
      if (!components) {
        throw new Error("There are no components for flow type \"".concat(flowType, "\""));
      }
      var filtered = _allElements["default"].filter(function (element) {
        if (!components.includes(element.code)) {
          return false;
        }

        // Don't allow report on the low levels
        if (['basic', 'premium'].includes(_this.props.restrictionsLevel)) {
          if (element.code === 'report') {
            return false;
          }
        }

        // Allow only some games to the premium restrictions
        if (_this.props.restrictionsLevel === 'premium') {
          var allowedGames = ['game_crooksandrobbers', 'game_bugzz', 'game_fireandice', 'game_runner', 'game_nottetris'];
          if (allowedGames.includes(element.code)) {
            return true;
          }
          if (/^game_/.test(element.code)) {
            return false;
          }
        }
        if (_this.props.restrictionsLevel === 'basic') {
          return !['dragdrop', 'list', 'menu', 'menuItem', /^game_/].some(function (type) {
            if (type instanceof RegExp && type.test(element.code)) {
              return true;
            }
            if (type === element.code) {
              return true;
            }
            return false;
          });
        }
        return true;
      });
      return (0, _sortBy2["default"])(filtered, [function (element) {
        return components.indexOf(element.code);
      }]);
    });
    _defineProperty(_assertThisInitialized(_this), "_getFlowPlayerType", function () {
      var flowType = _this.props.flowSettings.type;
      if (!flowType) {
        return null;
      }
      var flowTypeInfo = (0, _helpers.getFlowTypes)()[flowType];
      if (!flowTypeInfo) {
        throw new Error("There is no flow type \"".concat(flowType, "\""));
      }
      return flowTypeInfo.playerType;
    });
    _defineProperty(_assertThisInitialized(_this), "_getDataConnectorMeta", function (dataConnector) {
      if (dataConnector.category !== 'flow') {
        return null;
      }
      var element = _this.props.elements[dataConnector.id];
      if (!element) {
        return null;
      }
      var elementType = _allElements["default"].find(function (data) {
        return data.code === element.type;
      });
      var dataConnectors = elementType.getDataConnectors(element.settings);
      return dataConnectors[dataConnector.name] ? dataConnectors[dataConnector.name].meta : null;
    });
    _defineProperty(_assertThisInitialized(_this), "scrollToCurrentElement", function (e) {
      e && e.preventDefault();
      if (_this.listScrollShadow) {
        _this.listScrollShadow.scrollToNode({
          nodeId: "component_wrapper_".concat(_this.props.currentElement.id)
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getElements", function () {
      var ListComponent;
      var playerType = _this._getFlowPlayerType();
      if (playerType) {
        if (playerType === 'flow') {
          ListComponent = _FlowList["default"];
        } else {
          throw new Error("There is no list element for flow player type \"".concat(playerType, "\""));
        }
      }
      var currentElementType = (0, _find2["default"])(_allElements["default"], {
        code: _this.props.currentElement.type
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: "builder",
        className: _style["default"].builderWrapper,
        style: {
          height: _this.state.builderHeight
        }
      }, /*#__PURE__*/_react["default"].createElement(_ScrollShadow["default"], {
        className: _style["default"].componentsPane
      }, /*#__PURE__*/_react["default"].createElement(_Elements["default"], {
        elements: _this._getAllowedElements(),
        addElement: _this.props.addElement
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Trash["default"], {
        elements: _this.props.trash,
        elementTypes: _allElements["default"]
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].listPane
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].listToolbar
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: 'btn btn-secondary btn-sm ' + (_this.props.viewMode === 'brief' && 'active'),
        onClick: _this._changeToBriefMode,
        title: "Switch to brief mode"
      }, /*#__PURE__*/_react["default"].createElement(_paragraphJustify["default"], null)), /*#__PURE__*/_react["default"].createElement("a", {
        className: 'btn btn-secondary btn-sm ' + (_this.props.viewMode === 'preview' && 'active'),
        onClick: _this._changeToPreviewMode,
        title: "Switch to preview mode"
      }, /*#__PURE__*/_react["default"].createElement(_fileText["default"], null)))), /*#__PURE__*/_react["default"].createElement(_ScrollShadow["default"], {
        id: "flow_element_list",
        className: _style["default"].listContent,
        ref: function ref(item) {
          _this.listScrollShadow = item;
        }
      }, ListComponent && /*#__PURE__*/_react["default"].createElement(ListComponent, {
        elements: _allElements["default"],
        list: _this.props.list,
        dirtyElements: _this.props.dirtyElements,
        redoElements: _this.props.redoElements,
        newElements: _this.props.newElements,
        currentElement: _this.props.currentElement,
        changeCurrentElement: _this.props.changeCurrentElement,
        toggleElementPreview: _this.props.toggleElementPreview,
        viewMode: _this.props.viewMode,
        addElement: _this.props.addElement,
        moveElement: _this.props.moveElement,
        moveElementToTrash: _this.props.moveElementToTrash,
        moveElementFromTrash: _this.props.moveElementFromTrash,
        duplicateElement: _this.props.duplicateElement,
        undoChanges: _this.props.undoChanges,
        redoChanges: _this.props.redoChanges,
        flowSettings: _this.props.flowSettings,
        sectionCount: _this.props.sectionCount,
        completeSectionTree: _this.props.completeSectionTree,
        allQuestionStartNumbers: _this.props.allQuestionStartNumbers,
        verifyAndImportElements: _this.props.verifyAndImportElements,
        dynamicUserLists: _this.props.dynamicUserLists,
        dynamicUserListsValues: _this.props.dynamicUserListsValues,
        defaultValues: _this.props.defaultValues
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].settingsPane
      }, currentElementType && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].settingsTitleWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].settingsTitle
      }, currentElementType.icon && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].icon
      }, currentElementType.icon), currentElementType.name), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-secondary",
        onClick: _this.scrollToCurrentElement,
        title: "Scroll to the element",
        style: {
          padding: '4px 7px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_location["default"], null)))), /*#__PURE__*/_react["default"].createElement(_ScrollShadow["default"], {
        id: "flow_element_settings",
        className: _style["default"].settingsContent
      }, /*#__PURE__*/_react["default"].createElement(_Settings["default"], {
        key: _this.props.currentElement.id,
        elementTypes: _allElements["default"],
        elements: _this.props.elements,
        currentElement: _this.props.currentElement,
        getDataConnectorMeta: _this._getDataConnectorMeta,
        updateCurrentElementSettings: _this.props.updateCurrentElementSettings,
        currentPlayerTemplateName: _this.props.currentPlayerTemplateName,
        currentPlayerTemplateSettings: _this.props.currentPlayerTemplateSettings,
        dynamicUserLists: _this.props.dynamicUserLists,
        defaultValues: _this.props.defaultValues,
        showAdvancedSettings: _this.props.flowSettings.showAdvancedSettings,
        restrictionsLevel: _this.props.restrictionsLevel,
        flowSettings: _this.props.flowSettings
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "_saveFlow", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _ref2,
        _ref2$showNotificatio,
        showNotification,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$showNotificatio = _ref2.showNotification, showNotification = _ref2$showNotificatio === void 0 ? true : _ref2$showNotificatio;
            _context.next = 3;
            return _this.props.saveFlow(+_this.props.flowId, _this.props.codebookId);
          case 3:
            if (showNotification) {
              (0, _cccisdNotification["default"])('The survey has been saved');
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return _this;
  }
  _createClass(Builder, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        flow: {
          DataConnectorsPicker: _DataConnectorsPicker["default"],
          allowTts: this.props.restrictionsLevel !== 'basic',
          updateImageUrl: this.props.updateImageUrl
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadFlow(+this.props.flowId);
      this._handleResize();
      window.addEventListener('resize', this._handleResize);
      window.addEventListener('beforeunload', this._handleUnload);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._handleResize);
      window.removeEventListener('beforeunload', this._handleUnload);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.currentElement.id !== prevProps.currentElement.id || this.props.viewMode !== prevProps.viewMode) {
        this.scrollToCurrentElement();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      // Check if it's not test environment
      if (!this.props.addElement) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.props.loading
      }, /*#__PURE__*/_react["default"].createElement(_RestrictionsLevelContext["default"].Provider, {
        value: this.props.restrictionsLevel
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Prompt, {
        when: this.props.isSaveNeeded,
        message: function message() {
          return 'Your work is not saved! Are you sure you want to leave?';
        }
      }), this.props.showGoBackLink && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].linkBack
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        to: "/flow/admin"
      }, "Go back to flow list")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttonArea
      }, this.props.showTitle && /*#__PURE__*/_react["default"].createElement("h2", null, this.props.flowSettings.name), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
        className: 'btn btn-sm ' + (this.props.isSaveNeeded ? 'btn-warning' : 'btn-secondary'),
        onClick: this._saveFlow
      }, "Save"), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-secondary btn-sm"
        }, "Page settings"),
        title: "Page settings",
        size: "large"
      }, /*#__PURE__*/_react["default"].createElement(_FlowSettings["default"], {
        flowId: this.props.flowId,
        settings: this.props.flowSettings,
        updateData: this.props.updateSettings,
        flowPlayerType: this._getFlowPlayerType()
      })), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-secondary btn-sm"
        }, "Accommodations"),
        title: "Accommodations"
      }, /*#__PURE__*/_react["default"].createElement(_Accommodations["default"], {
        flowId: this.props.flowId,
        settings: this.props.flowSettings,
        updateData: this.props.updateSettings,
        flowPlayerType: this._getFlowPlayerType()
      })), ' ', this.props.restrictionsLevel !== 'basic' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-secondary btn-sm"
        }, "Speech"),
        title: "Speech"
      }, /*#__PURE__*/_react["default"].createElement(_TextToSpeech["default"], {
        saveFlow: this._saveFlow,
        reloadFlow: function reloadFlow() {
          return _this2.props.loadFlow(+_this2.props.flowId);
        }
      })), ' ') : null, !['basic', 'premium'].includes(this.props.restrictionsLevel) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-secondary btn-sm"
        }, "Variables"),
        title: "Variables"
      }, /*#__PURE__*/_react["default"].createElement(_Variables["default"], {
        flowId: this.props.flowId,
        saveFlow: this._saveFlow
      })), ' '), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-secondary btn-sm"
        }, "Export"),
        title: "Export"
      }, /*#__PURE__*/_react["default"].createElement(_Export["default"], {
        flowId: this.props.flowId,
        topId: this.props.rootId
      })), ' ', /*#__PURE__*/_react["default"].createElement(_Print["default"], null), " ", /*#__PURE__*/_react["default"].createElement(_PreviewWrapper["default"], null))), this._getElements()));
    }
  }]);
  return Builder;
}(_react["default"].Component);
_defineProperty(Builder, "propTypes", {
  flowId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  codebookId: _propTypes["default"].number,
  loading: _propTypes["default"].bool,
  addElement: _propTypes["default"].func,
  moveElement: _propTypes["default"].func,
  moveElementToTrash: _propTypes["default"].func,
  moveElementFromTrash: _propTypes["default"].func,
  duplicateElement: _propTypes["default"].func,
  undoChanges: _propTypes["default"].func,
  redoChanges: _propTypes["default"].func,
  changeCurrentElement: _propTypes["default"].func,
  currentElementId: _propTypes["default"].number,
  currentElement: _propTypes["default"].object,
  changeViewMode: _propTypes["default"].func,
  toggleElementPreview: _propTypes["default"].func,
  updateAnswer: _propTypes["default"].func,
  setAnswerError: _propTypes["default"].func,
  loadFlow: _propTypes["default"].func,
  saveFlow: _propTypes["default"].func,
  verifyAndImportElements: _propTypes["default"].func,
  list: _propTypes["default"].object,
  elements: _propTypes["default"].object,
  trash: _propTypes["default"].array,
  flowSettings: _propTypes["default"].object,
  dirtyElements: _propTypes["default"].array,
  redoElements: _propTypes["default"].array,
  newElements: _propTypes["default"].array,
  updateCurrentElementSettings: _propTypes["default"].func,
  updateSettings: _propTypes["default"].func,
  currentPlayerTemplateName: _propTypes["default"].string,
  currentPlayerTemplateSettings: _propTypes["default"].object,
  viewMode: _propTypes["default"].string,
  isSaveNeeded: _propTypes["default"].bool,
  sectionCount: _propTypes["default"].number,
  completeSectionTree: _propTypes["default"].func,
  allQuestionStartNumbers: _propTypes["default"].object,
  rootId: _propTypes["default"].number,
  dynamicUserLists: _propTypes["default"].array,
  dynamicUserListsValues: _propTypes["default"].object,
  defaultValues: _propTypes["default"].array,
  showGoBackLink: _propTypes["default"].bool,
  showTitle: _propTypes["default"].bool,
  restrictionsLevel: _propTypes["default"].string,
  updateImageUrl: _propTypes["default"].func
});
_defineProperty(Builder, "defaultProps", {
  showGoBackLink: false,
  showTitle: true
});
_defineProperty(Builder, "childContextTypes", {
  flow: _propTypes["default"].object
});
var Component = exports.Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactDndMultiBackend.DndProvider, {
    options: _HTML5toTouch["default"]
  }, /*#__PURE__*/_react["default"].createElement(Builder, props));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    loading: state.flow.builder.loading,
    currentElementId: state.flow.builder.currentElementId,
    currentElement: (0, _builder2.getCurrentElement)(state.flow.builder),
    elements: state.flow.builder.elements,
    list: (0, _builder2.getElementTree)(state.flow.builder),
    trash: state.flow.builder.trash,
    flowSettings: state.flow.builder.settings,
    dirtyElements: (0, _builder2.getDirtyElements)(state.flow.builder),
    redoElements: (0, _builder2.getRedoElements)(state.flow.builder),
    newElements: (0, _builder2.getNewElements)(state.flow.builder),
    viewMode: state.flow.builder.viewMode,
    isSaveNeeded: (0, _builder2.getSaveNeeded)(state.flow.builder),
    sectionCount: (0, _builder2.getSectionCount)(state.flow.builder),
    allQuestionStartNumbers: (0, _builder2.getAllQuestionStartNumbers)(state.flow.builder),
    rootId: state.flow.builder.rootId,
    currentPlayerTemplateName: (0, _builder2.getCurrentPlayerTemplate)(state.flow.builder).name,
    currentPlayerTemplateSettings: (0, _builder2.getCurrentPlayerTemplate)(state.flow.builder).settings,
    dynamicUserLists: state.flow.builder.dynamicUserLists,
    dynamicUserListsValues: (0, _builder2.getFakeDynamicUserListsValues)(state.flow.builder),
    defaultValues: state.flow.builder.defaultValues
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  updateCurrentElementSettings: _builder.updateCurrentElementSettings,
  updateSettings: _builder.updateSettings,
  addElement: _builder.addElement,
  moveElement: _builder.moveElement,
  moveElementToTrash: _builder.moveElementToTrash,
  moveElementFromTrash: _builder.moveElementFromTrash,
  duplicateElement: _builder.duplicateElement,
  undoChanges: _builder.undoChanges,
  redoChanges: _builder.redoChanges,
  changeCurrentElement: _builder.changeCurrentElement,
  changeViewMode: _builder.changeViewMode,
  toggleElementPreview: _builder.toggleElementPreview,
  updateAnswer: _player.updateAnswer,
  setAnswerError: _player.setAnswerError,
  saveFlow: _builder.saveFlow,
  completeSectionTree: _builder.completeSectionTree,
  loadFlow: _builder.loadFlow,
  verifyAndImportElements: _builder.verifyAndImportElements,
  updateImageUrl: _builder.updateImageUrl
})(Component);